import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Yaleo = {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Websites: {
    Layout: lazy(() => import('./containers/Websites/components/WebsitesLayout.tsx')),
    CrawlerConfig: lazy(() => import('./containers/Websites/containers/CrawlerConfig/index.tsx')),
    Websites: lazyNamed(() => import('./containers/Websites/containers/WebsitesList/index.tsx'), 'WebsitesList'),
    WebsitesRedirector: lazyNamed(() => import('./containers/Websites/components/WebsitesRedirector.tsx'), 'WebsitesRedirector'),
  },
  Placements: {
    PlacementList: lazy(() => import('./containers/PlacementList/index.tsx')),
    PlacementManage: lazy(() => import('./containers/PlacementManage/index.tsx')),
  },
  PlacementsNew: {
    PlacementList: lazyNamed(() => import('./containers/PlacementListV2/index.tsx'), 'PlacementListV2'),
    PlacementManage: lazyNamed(() => import('./containers/PlacementManageV2/index.tsx'), 'PlacementManageV2'),
  },
  BTAFeed: {
    Websites: lazyNamed(() => import('./containers/BTAFeed/pages/Websites/index.tsx'), 'Websites'),
    LegacyForm: lazyNamed(() => import('./containers/BTAFeed/pages/BTAFeedForm/index.tsx'), 'BTAFeedForm'),
    Form: lazyNamed(() => import('./scenes/BtaFeed/BtaFeedForm/index.tsx'), 'BtaFeedForm'),
  },
  /**
   * The whole section is hidden from navigation until further notice: https://gitlab.audienzz.ch/audienzz/audienzz/-/work_items/21588
   */
  Collect: {
    CrawlerConfigPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage/index.tsx')),
    CrawlerEditConfigPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage/CrawlerEditConfigPage.tsx')),
    CrawlerPathEditPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage/CrawlerPathConfigEdit.tsx')),
    CrawlerConfigsListPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigsListPage/index.tsx')),
  },
  AlgorithmsConfig: lazyNamed(() => import('./containers/AlgorithmsConfig/index.tsx'), 'AlgorithmsConfig'),
};
